import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import SearchBar from '../../components/SearchBar/SearchBar';
import TenantCard from '../../components/TenantCard/TenantCard';
import Pagination from '../../components/Pagination/Pagination';
import { FaTimes, FaPlus } from 'react-icons/fa';
import Cookies from 'js-cookie';


function HomePage() {
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [tenants, setTenants] = useState([]);
    const [domainsPerPage] = useState(25);
    const [editTenant, setEditTenant] = useState(null);
    const [newPassword, setNewPassword] = useState('');
    const [repeatPassword, setRepeatPassword] = useState('');
    const [notification, setNotification] = useState(null);
    const navigate = useNavigate(); 

    useEffect(() => {
        const fetchTenants= async () => {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/tenant`, {
                credentials: "include"
            });
            if (response.ok) {
                const body = await response.json();
                console.log(body.data);
                setTenants(body.data);
            } else if (response.status === 401) {
                Cookies.remove('session-id');
                navigate('/login');
            }
        }
        fetchTenants();
    }, []);

    useEffect(() => {
        if (notification) {
            const timer = setTimeout(() => setNotification(null), 2200);
            return () => clearTimeout(timer);
        }
    }, [notification]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleDelete = async (login) => {
        console.log('delete', login);

        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/tenant?login=${login}`, {
            method: 'DELETE',
            credentials: "include"
        });
        if (response.ok) {
            setTenants((prevTenants) => prevTenants.filter((tenant) => tenant.login !== login));
        } else if (response.status === 401) {
            Cookies.remove('session-id');
            navigate('/login');
        }
    };

    const handleLogin = async (login) => {    
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/tenant/login?login=${login}`, {
            method: 'GET',
            credentials: "include"
        });
        if (response.status === 401) {
            Cookies.remove('session-id');
            navigate('/login');
        } else {
            const location = response.headers.get('Location');
            if (location) {
                console.log('Redirecting to external link:', location);
                window.location.replace(location);
            } else {
                console.log('No Location header found');
            }
        }
    };

    const filteredRows = tenants.filter(row =>
        (row.title && row.title.toLowerCase().includes(searchQuery))
    );
    // Pagination logic
    const totalPages = Math.ceil(filteredRows.length / domainsPerPage);
    const startIndex = (currentPage - 1) * domainsPerPage;
    const currentRows = filteredRows.slice(startIndex, startIndex + domainsPerPage);

    const handlePasswordUpdate = async () => {
        if (newPassword !== repeatPassword) {
            setNotification({ type: 'error', message: "Passwords do not match!" });
            return;
        }
        
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/tenant/update-password`, {
            method: 'POST',
            credentials: "include",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ login: editTenant.login, passwd: newPassword })
        });
        
        if (response.ok) {
            setEditTenant(null);
            setNewPassword('');
            setRepeatPassword('');
            setNotification({ type: 'success', message: "Password updated successfully!" });
        } else {
            setNotification({ type: 'error', message: "Failed to update password!" });
        }
    };

    return (
        <div className='p-4'>
            {notification && (
                <div className={`fixed bottom-5 right-5 px-4 py-3 rounded-lg shadow-lg text-white transition-all duration-500 ease-in-out transform ${notification.type === 'success' ? 'bg-green-500' : 'bg-red-500'} ${notification ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
                    {notification.message}
                </div>
            )}

            <div className="flex flex-row items-center space-x-4 w-full max-w-md my-10 mx-auto">
                <SearchBar placeholder="Search by tenant name.." onSearch={setSearchQuery} />
                <Link to={`/add-tenant`} className="hover:underline">
                    <button className="rounded-full bg-blue-500 text-white px-3 py-3 rounded-full hover:bg-blue-600 transition-colors">
                        <FaPlus className='w-4 h-4' />
                    </button>
                </Link>
            </div>

            <div className="flex flex-col space-y-4 w-full max-w-md my-5 mx-auto">
                {currentRows.map((tenant) => (
                    <TenantCard 
                        key={tenant.login}
                        className=""
                        tenant={tenant}
                        onEdit={() => setEditTenant(tenant)}
                        onDelete={(login) => handleDelete(login)}
                        onLogin={(login) => handleLogin(login)}
                    />
                ))}

                <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
            </div>

            {editTenant && (
                <div className="fixed inset-0 flex justify-center items-center">
                    <div className="bg-white p-6 rounded-lg shadow-2xl w-96">
                        <h2 className="text-xl font-semibold mb-4 text-gray-800">Edit Password for: {editTenant.title}</h2>
                        <input type="password" className="w-full p-2 border rounded-lg mb-3 focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="New Password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
                        <input type="password" className="w-full p-2 border rounded-lg mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Repeat New Password" value={repeatPassword} onChange={(e) => setRepeatPassword(e.target.value)} />
                        <div className="flex justify-end space-x-3">
                            <button onClick={handlePasswordUpdate} className="px-5 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition">Submit</button>
                            <button onClick={() => {setEditTenant(null); setNewPassword(''); setRepeatPassword('');}} className="px-5 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition">Cancel</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default HomePage;
